import { gql, useQuery } from '@apollo/client';

const FEATURE_FLAG_QUERY = gql`
  query FeatureFlagForBubbleRecommendations($queryId: String!) {
    config {
      featureFlag: nonCachedGenericType(name: $queryId)
    }
  }
`;

export default function useFeatureFlagQuery(queryId, skipQuery = false) {
  const { data } = useQuery(FEATURE_FLAG_QUERY, {
    skip: skipQuery || !queryId,
    variables: { queryId },
  });

  return data?.config?.featureFlag?.value ?? false;
}
